import React from 'react';
import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const data = {
            url: `/admin/reports/sms/surcharges`,
            data: {
                data: [],
                metadata: []
            },
            userFilterAdvanced: true,
            userfilter:
                [
                    {
                        source: 'ATRDATE',
                        label: 'Date Range',
                        type: 'date_range',
                        options: ['date_only'],
                        default: {'from' : new Date(), 'to': new Date() }
                    }
                ],
            metadata: [
                {
                    label: 'ID',
                    source: 'row_id',
                    type: 'primary',
                    visible: false
                },
                {
                    label: 'Client ID',
                    source: 'client_number',
                    type: 'text',
                },
                {
                    label: 'Client Name',
                    source: 'client_name',
                    type: 'text',
                },
                {
                    label: 'Amount',
                    source: 'amount',
                    type: 'money',
                },
                {
                    label: 'Currency',
                    source: 'currency',
                    type: 'text'
                },
                {
                    label: 'Number of Messages',
                    source: 'nummessages',
                    type: 'text'
                },
            ]
        }
        return (
            <Panel title = "SMS Surcharges">
                <DataResource
                    data = {data}
                    {...this.props}
                    disableAdd
                    pagination
                />
            </Panel>
        )
    }
}
